import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import { AbstractControl, ValidationErrors} from '@angular/forms';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }






  form = new FormGroup({
    username: new FormControl('',[
        Validators.required,
        Validators.minLength(3),
        this.cannotContainSpace
    ]),
    dob: new FormControl('', Validators.required),

    father: new FormControl('', Validators.required),

    door: new FormControl('', Validators.required),

     
   

});

get username(){
    return this.form.get('username');
}

get dob(){
    return this.form.get('dob');
}





get father(){
    return this.form.get('father');
}


get door(){
    return this.form.get('door');
}






 cannotContainSpace(control:AbstractControl):ValidationErrors|null
{
          if((control.value as string).indexOf(' ')>=0)
          
          return {cannotContainSpace:true};

          return null;
}

login(){
    this.form.setErrors({
        invalidLogin:true,
        
        
    });

    


}


















}





// WEBPACK FOOTER //
// ./src/app/contactus/contactus.component.ts